<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH THÔNG BÁO</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới thông báo</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Trạng thái">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['status']"
                          placeholder="Lựa chọn trạng thái"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in trang_thai"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Dòng họ nhận">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['dong_ho_id']
                          "
                          filterable
                          placeholder="Nhập tên dòng họ"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in dong_ho"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>

                    <b-col md="4">
                      <el-form-item label="Tiêu đề">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['title']"
                          size="medium"
                          placeholder="Tiêu đề thông báo"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Trạng thái"
                align="center"
                width="120"
                fixed
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.status == 'sent'" class="text-box">
                    <p align="center" class="text-da-gui">Đã gửi</p>
                  </div>
                  <div v-if="scope.row.status == 'processing'" class="text-box">
                    <p align="center" class="text-dang-gui">Đang gửi</p>
                  </div>
                  <div v-if="scope.row.status == 'error'" class="text-box">
                    <p align="center" class="text-huy">Lỗi</p>
                  </div>
                  <div v-if="scope.row.status == 'new'" class="text-box">
                    <p align="center" class="text-cho-gui">Chờ gửi</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="dong_ho_id"
                label="Dòng họ nhận"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="title"
                label="Tiêu đề"
                min-width="200"
              ></el-table-column>
              <el-table-column
                prop="schedule"
                label="Thời điểm gửi"
                width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="createdTime"
                label="Thời điểm tạo"
                align="center"
                width="150"
                :sortable="mData.tableRules.allowSorting"
              >
              <template slot-scope="scope">
                {{ formatDate(scope.row.createdTime) }}
              </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="150px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    :disabled="
                      scope.row.status !== 'new' ||
                      scope.row.source !== 'viettoc'
                    "
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    :disabled="
                      scope.row.status !== 'new' ||
                      scope.row.source !== 'viettoc'
                    "
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormThongBao";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      dong_ho: [],
      trang_thai: [
        { label: "Chờ gửi", value: "new" },
        { label: "Đang gửi", value: "processing" },
        { label: "Đã gửi", value: "sent" },
        { label: "Lỗi", value: "error" },
      ],
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async fn_getDongHo() {
      try {
        const response = await mushroom.dong_ho.listAsync({
          limit: 100,
          sort: "-thoi_diem_tao",
        });
        response.result.forEach((item) => {
          this.dong_ho.push({
            value: item.id,
            label: item.ten,
          });
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = this.$route.query.page;
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields:
          "id,status,source,fromUserId,dong_ho_id,title,message,priority,schedule,imageId,createdTime",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachThongBao",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.notification_queue.listAsync(
          dataFilter
        );
        if (response.result) {
          let resData = await this.fn_changeData(response.result);
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          console.clear()
          this.loading = false;
        }
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
        this.loading = false;
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    formatDate(value) {
      return MethodService.formatDate(
         value,
          "datetime"
        )
    },
    async fn_changeData(data) {
      data.forEach(async (element) => {
        // element.createdTime = MethodService.formatDate(
        //   element.createdTime,
        //   "datetime"
        // );
        element.schedule = MethodService.formatDate(
          element.schedule,
          "datetime"
        );
        const response = await mushroom.dong_ho.findByIdAsync({
          id: element.dong_ho_id, // required
        });
        element.dong_ho_id = response.result.ten;
      });
      return data;
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietThongBao",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatThongBao",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.status, row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async fn_delete(status, id) {
      try {
        await mushroom.notification_queue.deleteAsync({ id: id });
        console.log("id của nút xóa", id);
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
      this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachThongBao",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["status"]) {
        this.mData.tableRules.dataSearch.value["status"] =
          this.mData.tableRules.dataSearch.value["status"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["fromUserId"]) {
        this.mData.tableRules.dataSearch.value["fromUserId"] =
          this.mData.tableRules.dataSearch.value["fromUserId"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["title"]) {
        this.mData.tableRules.dataSearch.value["title"] =
          this.mData.tableRules.dataSearch.value["title"].trim();
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_add() {
      this.$router.push({
        name: "ThemMoiThongBao",
      });
    },

    // xóa nhiều đánh giá
  },
  //run after render view
  async created() {
    await this.fn_getDongHo();
    await this.fn_hashUrl();
    await this.fn_initTable();
  },
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
.image-zone {
  border: 1px dashed #409eff;
  border-radius: 5px;
  padding: 5px;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
